export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const WEEKDAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const WEEKDAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const WEEKDAYS_COMPACT = ['Su', 'M', 'T', 'W', 'Th', 'F', 'S'];

export default {
  MONTHS,
  WEEKDAYS,
  WEEKDAYS_SHORT,
  WEEKDAYS_COMPACT,
};
